import { Card, CardBody } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'

const Byjus_Advantage = ({ profileData }) => {
    const isSmallDevice = useMediaQuery({ query: '(max-width: 767px)' })
    const videoObject = {
        heading: {
            banner_heading: 'Aakash Advantage',
        },
        SOE: {
            banner_video_url: 'https://www.youtube.com/embed/Rn3tEKLC9xY',
        },
        SOF: {
            banner_video_url: 'https://www.youtube.com/embed/Rn3tEKLC9xY',
        },
        SOM: {
            banner_video_url: 'https://www.youtube.com/embed/Rn3tEKLC9xY',
        },
        IAT: {
            SOE: {
                banner_video_url: 'https://www.youtube.com/embed/-GZTlL26Zp4',
            },
            SOF: {
                banner_video_url: 'https://www.youtube.com/embed/8lv1DzWOBeE',
            },
        },
        'MOCK-JEE': {
            url: 'https://www.youtube.com/embed/8lv1DzWOBeE',
        },
    }
    window.setInterval(trackClick, 100)
    function trackClick() {
        if (document.activeElement === document.querySelector('#anthe-video')) {
            window.webengage.track('iACST_db_video', {
                'mobile number': profileData.mobile_number,
                class: profileData.class && profileData.class.toString(),
                stream: profileData.stream,
                branchcode: profileData.exam_center_id,
            })
            window.focus()
        }
    }

    return (
        <>
            <div className="d-md-none p-3">
                <h3 className="font-size-lg text-grey-black mx-1 mb-3">
                    {videoObject?.heading?.banner_heading}
                </h3>
            </div>
            {profileData?.exam_type === 'iACST' ? (
                <Card
                    className="border-0"
                    style={{
                        width: '100%',
                        height: '100%',
                        filter: isSmallDevice
                            ? 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))'
                            : '',
                    }}
                >
                    <CardBody className="p-3">
                        <div className="d-none d-md-block">
                            <h3 className="font-size-lg text-grey-black">
                                {videoObject?.heading?.banner_heading}
                            </h3>
                        </div>

                        {videoObject[profileData.stream] &&
                        videoObject[profileData.stream]?.banner_video_url ? (
                            <iframe
                                title="ANTHE 1"
                                width="100%"
                                height="242px"
                                src={(videoObject[
                                    profileData.stream
                                ]?.banner_video_url).replace('watch?v=', 'embed/')}
                                id="anthe-video"
                            ></iframe>
                        ) : (
                            <iframe
                                title="iacst"
                                width="100%"
                                height="232px"
                                src={(videoObject['SOE']?.banner_video_url).replace(
                                    'watch?v=',
                                    'embed/',
                                )}
                                id="anthe-video"
                            ></iframe>
                        )}
                    </CardBody>
                </Card>
            ) : profileData?.exam_type === 'IAT' ? (
                <Card
                    className="border-0"
                    style={{
                        width: '100%',
                        height: '100%',
                        filter: isSmallDevice
                            ? 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))'
                            : '',
                    }}
                >
                    <CardBody className="p-3">
                        <div className="d-none d-md-block">
                            <h3 className="font-size-lg text-grey-black">
                                {videoObject?.heading?.banner_heading}
                            </h3>
                        </div>
                        {profileData?.exam_type === 'IAT' &&
                            videoObject?.IAT?.[profileData.stream]
                                ?.banner_video_url && (
                                <iframe
                                    title="IAT banner video"
                                    width="100%"
                                    height="242px"
                                    src={
                                        videoObject.IAT[profileData.stream]
                                            .banner_video_url
                                    }
                                    id="iat-video"
                                ></iframe>
                            )}
                    </CardBody>
                </Card>
            ) : profileData?.exam_type === 'MOCK-NEET' ? (
                <Card
                    className="border-0"
                    style={{
                        width: '100%',
                        height: '100%',
                        filter: isSmallDevice
                            ? 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))'
                            : '',
                    }}
                >
                    <CardBody className="p-3">
                        <div className="d-none d-md-block">
                            <h3 className="font-size-lg text-grey-black">
                                {videoObject?.heading?.banner_heading}
                            </h3>
                        </div>
                        <iframe
                            title="MOCK NEET"
                            width="100%"
                            height="232px"
                            src="https://www.youtube.com/embed/zZgUSslOCGI"
                            id="MOCK NEET"
                        ></iframe>
                    </CardBody>
                </Card>
            ) : profileData?.exam_type === 'MOCK-JEE' ? (
                <Card
                    className="border-0"
                    style={{
                        width: '100%',
                        height: '100%',
                        filter: isSmallDevice
                            ? 'drop-shadow(0px 4px 4px rgba(151, 151, 151, 0.2))'
                            : '',
                    }}
                >
                    <CardBody className="p-3">
                        <div className="d-none d-md-block">
                            <h3 className="font-size-lg text-grey-black">
                                {videoObject?.heading?.banner_heading}
                            </h3>
                        </div>
                        <iframe
                            title="MOCK JEE"
                            width="100%"
                            height="232px"
                            src={videoObject[profileData.exam_type].url}
                            id="MOCK JEE"
                        ></iframe>
                    </CardBody>
                </Card>
            ) : null}
        </>
    )
}
export default Byjus_Advantage
